import React from 'react';
import { useRouteParams } from '@/context/routeParamsContext';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { useLoungeDescription } from '@/hooks/loungesHooks/loungesHelperHooks';
import ExpandableText from '@/components/common/ExpandableText';

const LoungeDetailsOverview = () => {
  const { loungeId } = useRouteParams();
  const { lounges } = useCommonContent();

  const loungeDescription = useLoungeDescription(loungeId);
  return (
    <div>
      {loungeDescription && (
        <ExpandableText
          id="lounge-overview-description"
          className="pad-3-b tw-border-b tw-border-gray-300"
          text={loungeDescription}
          showMoreLabel={lounges?.showMore}
          showLessLabel={lounges?.hideMore}
        />
      )}
    </div>
  );
};

export default LoungeDetailsOverview;
